import { useQuery } from '@tanstack/react-query';
import { LoadedUser } from '../../interfaces';
import useUser from '../global/useUser';
import useGetSubscription from './useGetSubscription';
import { getAvailablePlans } from '../../services/subscriptions';

function useAvailablePlans() {
  const { user } = useUser<LoadedUser>();
  const { data: subscription } = useGetSubscription();

  return useQuery({
    queryKey: [
      'available-plans',
      user?.userId,
      user?.business?.id,
      user?.business?.type,
      subscription?.subscription?.planId,
    ],
    queryFn: () => getAvailablePlans(user?.business?.id!),
    enabled: !!user?.business?.id,
  });
}

export default useAvailablePlans;
